module.exports = __webpack_public_path__ + "static/assets/a046448265bf2b55750ad92b6b0f52fe.png";